<template>
  <v-container>
    <v-row class="text-center" justify="center">
      <v-col cols="12">
        <p class="text-body-1">
          <span v-if="!displayBeneficiaries">
            {{ $t('L_policy_beneficiaries_subtext_file') }}
          </span>
          <a :href="getTelCustServ" class="font-weight-regular">{{ getNumCustServ }} </a>
          <span class="font-weight-medium">{{
            $t('L_policy_contact_your_servicing', { 0: getNumCustServ })
          }}</span>
        </p>
      </v-col>
      <v-col cols="12">
        <p class="text-body-1">{{ $t('L_policy_submit_written_request') }}</p>
      </v-col>
      <v-col cols="12">
        <p class="text-body-1">
          {{ $t('L_policy_beneficiaries_company_US') }}
        </p>
        <p class="text-body-1">
          {{ $t('L_policy_submit_written_request_address') }}
        </p>
      </v-col>
      <v-col xs-12 md="12" pb-4>
        <p class="text-body-1">
          {{ $t('L_policy_submit_written_request_include_note') }}
        </p>
      </v-col>
    </v-row>
  </v-container>
</template>

<script lang="ts">
import { usePolicyStore } from '@/modules/policy/store/policy.store';
import { FEATURE_FLAGS } from '@/shared/models/constants.models';
import { useCustomerStore } from '@/stores/customer/customer.store';
import { useGlobalStore } from '@/stores/global/global.store';
import { mapState } from 'pinia';
import { defineComponent, type ComponentOptions } from 'vue';

const componentOptions: ComponentOptions = {
  name: 'BeneficiaryDefault',
  computed: {
    ...mapState(useCustomerStore, {
      getCustServNumWDash: 'getCustServNumWDash',
      getCustServNumWODash: 'getCustServNumWODash',
    }),
    ...mapState(useGlobalStore, {
      locale: 'getLocale',
    }),
    ...mapState(useGlobalStore, ['containsFeature', 'features']),
    ...mapState(usePolicyStore, {
      beneficiaries: 'beneficiaries',
    }),
    displayBeneficiaries() {
      return (
        this.containsFeature(FEATURE_FLAGS.BENEFICIARIES) &&
        this.beneficiaries &&
        this.beneficiaries?.length > 0
      );
    },
    getNumCustServ() {
      if (this.locale?.length > 0) {
        return this.getCustServNumWDash(this.locale);
      }
      return '';
    },
    getTelCustServ() {
      if (this.locale?.length > 0) {
        return `tel:${this.getCustServNumWODash(this.locale)}`;
      }
      return '';
    },
  },
};

export default defineComponent(componentOptions);
</script>
